module.exports = __webpack_public_path__ + "static/img/bj@2x.dc2173b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/information/bj@2x.png
// module id = HTWe
// module chunks = 69